export function idByIndex (objectsList, index) {
  return index === null ? null : objectsList[index].id
}

export function indexById (objectsList, id) {
  const index = objectsList?.findIndex((o, index) => {
    return o.id === id
  })
  return index >= 0 ? index : null
}

export function listToObject (list, key = 'id') {
  return Object.fromEntries(list?.map(it => ([it[key], it]) || []))
}

export function addUniqueToArray (array, item) {
  const set = new Set(array)
  set.add(item)
  return [...set]
}

export function removeFromArray (array, item) {
  const set = new Set(array)
  set.delete(item)
  return [...set]
}
